import CoPartnerClub from '../CoPartnerClub'
import { useNavigate } from 'react-router-dom'
import { Footer } from '../../../components/footer';

const ManualSlotReward = () => {
    const navigate = useNavigate();
    return (
        <div className="mainContent">

            <div className="pageContent def-py-30">

                <div className='container'>
                    <div className="appPagetitle"><button className='btn btnBack' onClick={() => navigate('/royalty-wallet')}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.16699 10H15.8337" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M4.16699 10L7.50033 13.3333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M4.16699 10.0003L7.50033 6.66699" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button> Manual Slot Reward</div>
                    <CoPartnerClub back={'manual-slot-reward'}/>
                </div>
            </div>
            <Footer />
        </div>

    )
}

export default ManualSlotReward
